module.exports = __webpack_public_path__ + "img/6.cc3027d1.png";